import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { TextBody } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { SECTION_NAME_MAPPING } from "../ExpandedSearchResultSections/ExpandedSearchResultSections";
import { ExpandedSearchSection } from "../ExpandedSearchSection";
import { ExpandedSearchResultSectionSkeleton } from "./ExpandedSearchResultSectionSkeleton";
export function ExpandedSearchResultSection(t0) {
  const $ = _c(13);
  const {
    section,
    isLoading: t1,
    results,
    renderResult,
    resultsListRef,
    doesParentHaveResults,
    children,
    selectedChain: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const selectedChain = t2 === undefined ? "all" : t2;
  const heading = SECTION_NAME_MAPPING[section];
  const t = useTranslations("ExpandedSearchResultSection");
  const {
    isChainCurrencyOnly
  } = useChains();
  const isSectionSupportedOnChain = () => {
    if (selectedChain === "all") {
      return true;
    }
    if (isChainCurrencyOnly(selectedChain)) {
      return section !== "collection" && section !== "item";
    }
    return true;
  };
  if (isLoading && isSectionSupportedOnChain()) {
    let t3;
    if ($[0] !== section) {
      t3 = <ExpandedSearchResultSectionSkeleton section={section} />;
      $[0] = section;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  if (!isSectionSupportedOnChain()) {
    return null;
  }
  if (!children && results.length === 0 && doesParentHaveResults) {
    return;
  }
  const t3 = `ExpandedSearchMenu${heading}`;
  let t4;
  if ($[2] !== children || $[3] !== heading || $[4] !== renderResult || $[5] !== results || $[6] !== resultsListRef || $[7] !== t) {
    t4 = children ?? (results.length > 0 ? results.map(result => renderResult(result, resultsListRef)) : <TextBody className="my-1 px-3 opacity-25">{t("noResultsFound", {
        heading
      })}</TextBody>);
    $[2] = children;
    $[3] = heading;
    $[4] = renderResult;
    $[5] = results;
    $[6] = resultsListRef;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== heading || $[10] !== t3 || $[11] !== t4) {
    t5 = <ExpandedSearchSection data-testid={t3} heading={heading}>{t4}</ExpandedSearchSection>;
    $[9] = heading;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}